/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import logo from "../../assets/Southwest_Logo_Light.png";

const AppHeader = () => {
    return (
        <div>
            <a href="/">
                <img className="logo" src={logo} alt="Southwest logo"></img>
            </a>
            <h1 className="app-header">Wheel And Brake Tag Printer</h1>
        </div>
    );
};

export default AppHeader;